<div class=" d-none d-sm-block">
	<!------------------------------------------TITLE----------------------------------------------->
	<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
		<div class="head-card p-1 inner-title-box">
		  <h1 class="title-text text-center font-weight-bold">
			MULTI BRAND SCREW AIR
		  </h1>
		  <div class="text-right">
			<h5 class="text-light">
				<span class="sub-menu" routerLink="/home-page">HOME </span>&nbsp;
				<span class="sub-menu" routerLink="/contact-us"> CONTACT</span>&nbsp;
				<span class="sub-menu" routerLink="/ourproducts"> PRODUCTS</span>&nbsp;
				<span class="sub-menu" routerLink="/verticals"> SERVICES</span>&nbsp;
			</h5>
		  </div>
		</div>
	   </div>

	  <!--------------------------------------------------TITLE END-------------------------------------------->
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<div class="content-container">   
		<a class="mail-call" href="tel:8489359948">
            <span class="fa fa-phone" aria-hidden="true"></span>
        </a>  
		<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
		</a>   
		<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
			<span class="fa fa-whatsapp"></span>
		</a>
        <img src="../../../assets/img/slides img/screw-air-compressor.jpeg" alt="">
        <br>
        <ul>
            <li>Air End Repairs: Precision repair and rebuilding of air ends to restore like-new performance.</li>
            <li> Motor & Drive System Maintenance: Ensuring seamless operation of motors and VFD systems.</li>
            <li>&nbsp; Filtration System Replacement: Replacement and cleaning of air and oil filters to maintain clean airflow.</li>
			<br>
			<img src="../../../assets/img/active-gallery/gallery.jpeg" alt="">
			<br>
			<br>
            <li>Heat Exchanger Cleaning: Preventing overheating with professional cleaning and maintenance.</li>
            <li>Leak Detection & Repair: Identifying and fixing air leaks to enhance system efficiency.</li>
            <li>Oil Analysis & Change: Maintaining proper lubrication for prolonged equipment life.</li>
			<br>
			<img src="../../../assets/img/active-gallery/gallery2.jpeg" alt="">
			<br>
			<br>
		</ul>




        <p>
            Expertise Across Brands: Our team is trained and experienced in servicing a wide range of air compressor brands, including Atlas Copco, Ingersoll Rand, Kaeser,
 Elgi, Sullair, and many more. We ensure your equipment receives brand-specific care.
			<br>
			<br>
 <img src="../../../assets/img/active-gallery/gallery3.jpeg" alt="">
 <br>
        </p>
        <p>
            Original Spare Parts: We supply and install genuine spare parts or high-quality OEM alternatives to ensure optimal performance and longevity.
        </p>
    </div>
</div>




<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">
	<a class="mail-call" href="tel:8489359948">
		<span class="fa fa-phone" aria-hidden="true"></span>
	</a>  
	<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
	</a>   
	<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
		<span class="fa fa-whatsapp"></span>
	</a>
	<img src="../../assets/img/multi-brand/multibrand1.webp" alt="">
	<br>
		<ul>
            <li>Air End Repairs: Precision repair and rebuilding of air ends to restore like-new performance.</li>
            <li> Motor & Drive System Maintenance: Ensuring seamless operation of motors and VFD systems.</li>
            <li>&nbsp; Filtration System Replacement: Replacement and cleaning of air and oil filters to maintain clean airflow.</li>
            <li>Heat Exchanger Cleaning: Preventing overheating with professional cleaning and maintenance.</li>
            <li>Leak Detection & Repair: Identifying and fixing air leaks to enhance system efficiency.</li>
            <li>Oil Analysis & Change: Maintaining proper lubrication for prolonged equipment life.</li>
        </ul>
    </div>
